import $4mS6r$intltagarAEmjs from "../intl/tag/ar-AE.mjs";
import $4mS6r$intltagbgBGmjs from "../intl/tag/bg-BG.mjs";
import $4mS6r$intltagcsCZmjs from "../intl/tag/cs-CZ.mjs";
import $4mS6r$intltagdaDKmjs from "../intl/tag/da-DK.mjs";
import $4mS6r$intltagdeDEmjs from "../intl/tag/de-DE.mjs";
import $4mS6r$intltagelGRmjs from "../intl/tag/el-GR.mjs";
import $4mS6r$intltagenUSmjs from "../intl/tag/en-US.mjs";
import $4mS6r$intltagesESmjs from "../intl/tag/es-ES.mjs";
import $4mS6r$intltagetEEmjs from "../intl/tag/et-EE.mjs";
import $4mS6r$intltagfiFImjs from "../intl/tag/fi-FI.mjs";
import $4mS6r$intltagfrFRmjs from "../intl/tag/fr-FR.mjs";
import $4mS6r$intltagheILmjs from "../intl/tag/he-IL.mjs";
import $4mS6r$intltaghrHRmjs from "../intl/tag/hr-HR.mjs";
import $4mS6r$intltaghuHUmjs from "../intl/tag/hu-HU.mjs";
import $4mS6r$intltagitITmjs from "../intl/tag/it-IT.mjs";
import $4mS6r$intltagjaJPmjs from "../intl/tag/ja-JP.mjs";
import $4mS6r$intltagkoKRmjs from "../intl/tag/ko-KR.mjs";
import $4mS6r$intltagltLTmjs from "../intl/tag/lt-LT.mjs";
import $4mS6r$intltaglvLVmjs from "../intl/tag/lv-LV.mjs";
import $4mS6r$intltagnbNOmjs from "../intl/tag/nb-NO.mjs";
import $4mS6r$intltagnlNLmjs from "../intl/tag/nl-NL.mjs";
import $4mS6r$intltagplPLmjs from "../intl/tag/pl-PL.mjs";
import $4mS6r$intltagptBRmjs from "../intl/tag/pt-BR.mjs";
import $4mS6r$intltagptPTmjs from "../intl/tag/pt-PT.mjs";
import $4mS6r$intltagroROmjs from "../intl/tag/ro-RO.mjs";
import $4mS6r$intltagruRUmjs from "../intl/tag/ru-RU.mjs";
import $4mS6r$intltagskSKmjs from "../intl/tag/sk-SK.mjs";
import $4mS6r$intltagslSImjs from "../intl/tag/sl-SI.mjs";
import $4mS6r$intltagsrSPmjs from "../intl/tag/sr-SP.mjs";
import $4mS6r$intltagsvSEmjs from "../intl/tag/sv-SE.mjs";
import $4mS6r$intltagtrTRmjs from "../intl/tag/tr-TR.mjs";
import $4mS6r$intltagukUAmjs from "../intl/tag/uk-UA.mjs";
import $4mS6r$intltagzhCNmjs from "../intl/tag/zh-CN.mjs";
import $4mS6r$intltagzhTWmjs from "../intl/tag/zh-TW.mjs";

var $6662b86525cff4aa$exports = {};


































$6662b86525cff4aa$exports = {
    "ar-AE": $4mS6r$intltagarAEmjs,
    "bg-BG": $4mS6r$intltagbgBGmjs,
    "cs-CZ": $4mS6r$intltagcsCZmjs,
    "da-DK": $4mS6r$intltagdaDKmjs,
    "de-DE": $4mS6r$intltagdeDEmjs,
    "el-GR": $4mS6r$intltagelGRmjs,
    "en-US": $4mS6r$intltagenUSmjs,
    "es-ES": $4mS6r$intltagesESmjs,
    "et-EE": $4mS6r$intltagetEEmjs,
    "fi-FI": $4mS6r$intltagfiFImjs,
    "fr-FR": $4mS6r$intltagfrFRmjs,
    "he-IL": $4mS6r$intltagheILmjs,
    "hr-HR": $4mS6r$intltaghrHRmjs,
    "hu-HU": $4mS6r$intltaghuHUmjs,
    "it-IT": $4mS6r$intltagitITmjs,
    "ja-JP": $4mS6r$intltagjaJPmjs,
    "ko-KR": $4mS6r$intltagkoKRmjs,
    "lt-LT": $4mS6r$intltagltLTmjs,
    "lv-LV": $4mS6r$intltaglvLVmjs,
    "nb-NO": $4mS6r$intltagnbNOmjs,
    "nl-NL": $4mS6r$intltagnlNLmjs,
    "pl-PL": $4mS6r$intltagplPLmjs,
    "pt-BR": $4mS6r$intltagptBRmjs,
    "pt-PT": $4mS6r$intltagptPTmjs,
    "ro-RO": $4mS6r$intltagroROmjs,
    "ru-RU": $4mS6r$intltagruRUmjs,
    "sk-SK": $4mS6r$intltagskSKmjs,
    "sl-SI": $4mS6r$intltagslSImjs,
    "sr-SP": $4mS6r$intltagsrSPmjs,
    "sv-SE": $4mS6r$intltagsvSEmjs,
    "tr-TR": $4mS6r$intltagtrTRmjs,
    "uk-UA": $4mS6r$intltagukUAmjs,
    "zh-CN": $4mS6r$intltagzhCNmjs,
    "zh-TW": $4mS6r$intltagzhTWmjs
};


export {$6662b86525cff4aa$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
